import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=00a28cb6&scoped=true"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"
import style0 from "./Reservation.vue?vue&type=style&index=0&id=00a28cb6&prod&scoped=true&lang=css"
import style1 from "./Reservation.vue?vue&type=style&index=1&id=00a28cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a28cb6",
  null
  
)

export default component.exports